import { TranslationDataType } from 'resources/translation';

import { getValidationConstructor } from './validationConstructor';

export const getDateValidation = (t: TranslationDataType) => ({
  standart: getValidationConstructor(t, /^(1[0-2]|0[1-9])\/([2-9][0-9])+$/, 'invalid_date'),
});
